export default __webpack_public_path__ + "static/media/faith.ca0105d7.jpg";